import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { FRAUD_ALERT_STATUS_LABEL } from "shared/app/fraudAlertUtils";
import type { FraudAlertStatus } from "api/propertyShield";

const STATUS_VARIANT: Record<FraudAlertStatus, BadgeVariant> = {
  pending_confirmation: BadgeVariant.PRIMARY,
  active: BadgeVariant.WARNING,
  removed: BadgeVariant.BASE,
  false_red_flag: BadgeVariant.BASE
};

export const FraudAlertStatusBadge = ({
  status
}: {
  status: FraudAlertStatus;
}) => (
  <Badge
    variant={STATUS_VARIANT[status]}
    size={BadgeSize.SM}
    borderless={false}
  >
    {FRAUD_ALERT_STATUS_LABEL[status]}
  </Badge>
);
